import { TranslateService } from '@ngx-translate/core';
import { BaseAsyncValue } from '../../../../shared/models/async-value';
import { Observable } from 'rxjs';
import { of } from 'rxjs';

export class DecimalProvider extends BaseAsyncValue<number> {
  getValue(...args: any[]): Observable<number> {
    const translate = this.injector.get<TranslateService>(TranslateService);
    return of(Number(translate.instant('global.decimalNumbers')));
  }
}
